import React from 'react'

// Artwork for the top-right of the home page: a drawn desk scene.
const DeskScene = () => (
    <svg className="home-illustration-svg" viewBox="0 0 340 230" aria-hidden="true">
        <circle cx="210" cy="112" r="96" fill="#dfe6ff" />
        <circle cx="292" cy="58" r="26" fill="#e9edff" />
        {/* sparkle */}
        <path d="M96 40 l5 13 13 5 -13 5 -5 13 -5 -13 -13 -5 13 -5z" fill="#c7d2fe" />
        {/* desk */}
        <rect x="70" y="182" width="270" height="10" rx="5" fill="#c9d3f5" />
        {/* laptop */}
        <rect x="150" y="96" width="118" height="78" rx="8" fill="#94a3c8" />
        <rect x="157" y="103" width="104" height="64" rx="4" fill="#eef2ff" />
        <rect x="168" y="114" width="56" height="6" rx="3" fill="#a5b4fc" />
        <rect x="168" y="126" width="80" height="5" rx="2.5" fill="#c7d2fe" />
        <rect x="168" y="136" width="66" height="5" rx="2.5" fill="#c7d2fe" />
        <rect x="168" y="148" width="40" height="10" rx="5" fill="#4f6bed" />
        <path d="M136 174 h146 l-10 8 h-126z" fill="#7f8db3" />
        {/* book stack */}
        <rect x="270" y="160" width="62" height="12" rx="3" fill="#4f6bed" />
        <rect x="276" y="148" width="54" height="12" rx="3" fill="#00c596" />
        <rect x="272" y="136" width="58" height="12" rx="3" fill="#f05d70" />
        <rect x="276" y="172" width="54" height="10" rx="3" fill="#f4a00b" />
        {/* pencil cup */}
        <rect x="112" y="152" width="22" height="30" rx="4" fill="#fbbf24" />
        <rect x="116" y="132" width="4" height="22" rx="2" fill="#4f6bed" />
        <rect x="124" y="128" width="4" height="26" rx="2" fill="#f05d70" />
    </svg>
);

const HomeIllustration = () => (
    <div className="home-illustration" aria-hidden="true">
        <p className="home-illustration-quote">
            Dream Big...<br /><span>Achieve More...</span>
        </p>
        <DeskScene />
    </div>
);

export default HomeIllustration;
